import React from "react";
import { useNavigate } from "react-router-dom";

import {
  Video,
  Radio,
  Images,
  Clapperboard,
  Upload,
  CreditCard,
  Users,
  UserRound,
  Search,
  Bookmark,
  ShieldCheck,
  MonitorPlay,
} from "lucide-react";

import FeatureCard from "./components/FeatureCard";
import BackButton from "../../components/buttons/back/BackButton";

import PageWrapper from "../../components/layout/page/PageWrapper";

import { PageHeader } from "../../components/layout/header/Header";
import { PageHeading } from "../../components/common/heading/Heading";

import "./FeaturesPage.css";

const FEATURES = [
  {
    title: "Video Streaming",
    description:
      "Watch sports matches, events and on-demand replays in high definition, across your devices.",
    icon: <Video size={24} />,
  },
  {
    title: "Live Streaming",
    description:
      "Broadcast sports matches and events live using professional streaming tools, with support for recordings and replays.",
    icon: <Radio size={24} />,
  },
  {
    title: "Photo Albums",
    description:
      "Create and share photo albums to capture sporting events, team memories and memorable moments.",
    icon: <Images size={24} />,
  },
  {
    title: "Pops",
    description:
      "Upload, watch and share short videos featuring highlights, skills and memorable sporting moments.",
    icon: <Clapperboard size={24} />,
  },
  {
    title: "Creator Studio",
    description:
      "Upload, organise and manage videos, Pops, photo albums and live streams through your creator dashboard.",
    icon: <Upload size={24} />,
  },
  {
    title: "Content Monetisation",
    description:
      "Unlock paid video content through secure payments, helping creators generate revenue from their sports footage.",
    icon: <CreditCard size={24} />,
  },
  {
    title: "Groups",
    description:
      "Create and manage groups, invite members, approve join requests and organise content for your sports community.",
    icon: <Users size={24} />,
  },
  {
    title: "Talent ID",
    description:
      "Build a sporting profile to showcase your sports, experiences, achievements and media in one place.",
    icon: <UserRound size={24} />,
  },
  {
    title: "Content Discovery",
    description:
      "Search and discover public videos, Pops, albums, live streams and talent profiles across Katch.",
    icon: <Search size={24} />,
  },
  {
    title: "Saved Pops",
    description:
      "Save your favourite Pops and return to the sporting moments you want to watch again.",
    icon: <Bookmark size={24} />,
  },
  {
    title: "Content Privacy",
    description:
      "Manage who can access your content with public, unlisted, private and group-based visibility options.",
    icon: <ShieldCheck size={24} />,
  },
  {
    title: "Creator Channels",
    description:
      "Build your creator presence with a dedicated channel where viewers can discover your published sports content.",
    icon: <MonitorPlay size={24} />,
  },
];

export default function FeaturesPage() {
  const navigate = useNavigate();

  return (
    <PageWrapper>
      <br />
      <PageHeader>
        <BackButton onClick={() => navigate(-1)} />

        <PageHeading
          title="Katch Features"
          subTitle="Stream, share, manage and monetise sports content with tools built for creators, athletes and sporting communities."
        />
      </PageHeader>

      <div className="features-page__grid">
        {FEATURES.map((feature) => (
          <FeatureCard key={feature.title} {...feature} />
        ))}
      </div>
    </PageWrapper>
  );
}
